// extracted by mini-css-extract-plugin
export default {"fr-view":"TourTooltip_fr-view__0UDdM","container":"TourTooltip_container__QFokV"};